module.exports = __webpack_public_path__ + "8b762db6c115409caf4b3abd637cff41.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-21.png
// module id = 3317
// module chunks = 0